import { Injectable } from '@angular/core';
import { ProductsService } from '@vestiaire/api-sdk-angular';

@Injectable()
export class DiscussionsService {
  constructor(private productsService: ProductsService) {}

  postProductComment(post) {
    this.productsService.createProductComment(post.productId, post.commentForm);
  }
}
